import Vue from 'vue';
import cronstrue from 'cronstrue';

function initTemplateOptions(options) {
    if (!options) {
        return null;
    }
    for (let optKey in options) {
        if (options.hasOwnProperty(optKey)) {
            let optList = options[optKey];
            optList.forEach(opt => {
                // add error and value
                opt.error = null;
                opt.value = null;
            });
        }
    }
    return options;
}

function Item(config) {
    if (!(this instanceof Item)) {
		return new Item(config);
	}
	if (config) {
		Vue.util.extend(this, config);
	}
}

Item.prototype = {
	constructor: Item,

	id: '',
    name: '',
    description: '',
    shortDescription: '',
    type: '',
    state: '',
    template: {},
    templateOptions: null,
    signalOptions: [],
    uiOptions: {},
    cronSelections: [],
    logo: '',
    appId: null
};

Item.fromDTO = function(dto) {
    if (dto === null || dto === undefined) {
		return null;
    }

	return new Item({
		id: dto.id,
        name: dto.name,
        description: dto.description,
        shortDescription: dto.shortDescription,
        type: dto.type,
        state: dto.state,
        template: dto.template,
        templateOptions: initTemplateOptions(dto.templateOptions),
        signalOptions: dto.signalOptions,
        uiOptions: dto.uiOptions || {},
        cronSelections: dto.cronSelections,
        logo: dto.logo,
        appId: dto.appId
	});
};

Item.prototype.cronReadable = function (cronExpr = null) {
    if (!cronExpr) {
        // use default from template
        cronExpr = this.template.cron;
    }
    try {
        if(cronExpr === '0 0 * * *') {
            return 'Daily';
        }
        return cronstrue.toString(cronExpr);
    } catch (e) {
        return null;
    }
};

Item.prototype.isAvailable = function () {
    return this.state === 'AVAILABLE';
};

Item.prototype.getCostLabel = function (useDefault = false) {
    if (useDefault) {
        let cronExpr = this.template.cron;
        let selection = this.cronSelections.find(selection => selection.cronExpr === cronExpr);
        return selection ? selection.cost : '';
    }

    let label = 'Free';
    let costs = this.cronSelections.map(selection => Number(selection.cost));
    if (costs && costs.length) {
        let lowestCost = Math.min(...costs);
        if (lowestCost === 0 && this.cronSelections.length > 1) {
            label += '+';
        } else if(lowestCost > 0) {
            label = `${lowestCost}${this.cronSelections.length > 1 ? '+' : ''}`;
        }
    }
    return label;
};

export default Item;



// WEBPACK FOOTER //
// ./src/modules/marketplace/item.js